import WorkOrderRoutes from "./work-oder";
import ProductionRoutes from "./production";

export default [
    ...WorkOrderRoutes,
    ...ProductionRoutes
];
